// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "v4assets/" + chunkId + "." + {"1242":"5d0cbb1c820f736167df","2552":"dbe247faa7b23055d8e2","6037":"2acec361fa53edd67f06"}[chunkId] + ".css";
};